import {
	ADD_PART,
	SET_FULL_PARTS,
	REMOVE_PART,
	CLEAR_CART,
	SET_LOADING,
	UPDATE_PART,
	SET_CART,
	SET_CART_PRODUCTS
} from './mutation-types'

const remove = (id, list) => {
	let hits = list.filter(item => item.nearestParentId === id || item.partId === id)
	hits.map(hit => {
		if (hit.partId !== id) {
			hits = hits.concat(list.filter(item => item.nearestParentId === hit.partId))
		}
	})
	return list.filter(item => !hits.find(hit => hit.partId === item.partId))
}

export default {

	[SET_LOADING] (state, data) {
		state.loading = { ...state.loading, ...data }
	},
	[SET_CART] (state, data) {
		state.cart = data
	},
	[SET_CART_PRODUCTS] (state, data) {
		state.cartProducts = data
	},

	[ADD_PART] (state, part) {
		state.parts = [...state.parts, part]
		localStorage.setItem('CartContent', JSON.stringify(state.parts))
	},

	[UPDATE_PART] (state, part) {
		let updatedPart = state.parts.find(_part => _part.partId === part.id)
		let updateFullPart = state.fullParts.find(_part => _part.id === part.id)

		const updatedParts = state.parts.filter(_part => _part.partId !== part.id )
		const updatedFullParts = state.fullParts.filter(_part => _part.id !== part.id )

		updateFullPart = { ...updateFullPart, selectedQuantity: part.selectedQuantity }
		updatedPart = { ...updatedPart, selectedQuantity: part.selectedQuantity }

		state.parts = [...updatedParts, updatedPart]
		state.fullParts = [...updatedFullParts, updateFullPart]

		localStorage.setItem('CartContent', JSON.stringify(state.parts))
	},

	[SET_FULL_PARTS] (state, parts) {
		state.fullParts = parts.map(part => {
			const blueprint = state.parts.find(_part => _part.partId === part.id)
			return {
				...part,
				selectedQuantity: blueprint.selectedQuantity
			}
		})
	},

	[REMOVE_PART] (state, partId) {
		const remainingParts = remove(partId, state.parts)
		state.parts = remainingParts
		if (!remainingParts.length) {
			localStorage.removeItem('CartContent')
		} else {
			localStorage.setItem('CartContent', JSON.stringify(remainingParts))
		}
	},

	[CLEAR_CART] (state) {
		state.parts = []
		localStorage.setItem('CartContent', JSON.stringify(state.parts))
	}
}
